import React, { useEffect, useId, useState } from "react";
import { FaStar } from "react-icons/fa";
import vitLogo from "../../assets/logos/VIT-logo.svg";
import srmLogo from "../../assets/logos/SRM-logo.png";
import sastraLogo from "../../assets/logos/SASTRA-logo.png";
import rmkLogo from "../../assets/logos/RMK-logo.gif";
import kecLogo from "../../assets/logos/KEC-logo.png";
import { Card, Container, SectionHead } from "./ui";

const VISIBLE_CARDS = 3;
const AUTOPLAY_MS = 8000;

/** Long institutional quotes are clamped in the card; the full text stays in the DOM. */
const clampStyle = {
  display: "-webkit-box",
  WebkitLineClamp: 8,
  WebkitBoxOrient: "vertical",
  overflow: "hidden",
};

const Testimonials1 = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      image: vitLogo,
      text: `We at VIT offer Campus Placement Training to all our students, starting from the
                freshmen, to hone their readiness to attend campus recruitments with confidence
                and zest. As a testimony to our commitment, we currently hold the Limca Book of
                Records for placing the maximum number of students (1820) in a single placement
                drive. In line with our objective, we seldom compromise on quality and hence it
                was an easy decision to count on SMART Training Resources India Pvt. Ltd. to be
                our training partner. They have been regularly conducting Campus Placement
                Training as per our requirement and to our utmost satisfaction.`,
      name: "Vellore Institute of Technology",
      title: "Premier University",
      rating: 5,
      id: useId(),
    },
    {
      image: srmLogo,
      text: `SRM University is one of the top-ranking universities in India with over 38,000
                students and more than 2600 faculty members across all the campuses. Time and
                again we have been creating records in Placement by placing our students in top
                notch companies at high level salaries. SMART Training Resources India Pvt. Ltd.,
                as our training vendor, has been providing service of the highest quality. SMART
                has proved their mettle time and again by preempting the corporate test standards
                and preparing students well in advance. From our experience over the years with
                SMART and from our students' feedback we can say that their programmes are
                highly effective and very relevant in today's competitive scenario.`,
      name: "SRM Institute of Technology",
      title: "Leading University",
      rating: 5,
      id: useId(),
    },
    {
      image: sastraLogo,
      text: `We are happy to say that SMART is working with us for several years and have
                been conducting Placement Training Programme for our students. The need to
                educate  and  train  young  men  and  women  to  hone  them  into  professionally
                competent,  rounded  personalities  has  been  our  burning  passion  at  SASTRA
                University. We are committed to excellence and have consistently maintained the
                highest standards by ensuring quality teaching of the finest caliber. We not only
                train and educate students to be technically competent and efficient but also
                concentrate on training the students in other essential skills, such as employability
                skills and life skills. This Training Programme has very positive feedback and is a
                great value addition to our students' skill sets. We congratulate SMART on their
                continuing success.`,
      name: "SASTRA University",
      title: "Renowned Institution",
      rating: 5,
      id: useId(),
    },
    {
      image: rmkLogo,
      text: `At  R.M.K Group  of Institutions,  our partnership  with  SMART  has  been  a
                cornerstone of our commitment to providing holistic education and professional
                development opportunities to our students. Through their Placement Training
                Programmes, our students have been equipped with invaluable skills essential for
                their professional journey. Our collaboration with SMART reflects our shared
                dedication  to  nurturing  well-rounded  individuals.  The  positive  feedback
                underscores the effectiveness of SMART's Training Programme in enriching our
                students' learning experiences. We extend our sincere appreciation too SMART for
                their continued dedication in empowering our students, and we look forward to
                further strengthening our partnership for the benefit of our student community.`,
      name: "R.M.K Group of Institutions",
      title: "Educational Group",
      rating: 5,
      id: useId(),
    },
    {
      image: kecLogo,
      text: `SMART Training Resources have been the pioneers in conducting placement
                training programmes in India and they have been training Kongu Engineering
                College students since 2007. We find a rare set up strengths in this organization.
                They have an in-house team that develops error free training materials and the same
                is complemented by efficient and effective trainers who offer a consistent and top-
                notch delivery of training sessions. SMART Training Resources are in the forefront
                of the placement training market by their sheer commitment to quality which is
                reflected in their ability and willingness to develop new course materials as per the
                latest test matrix of recruiters. We are happy and delighted by their service and we
                wish them all the best in all their future endeavors.`,
      name: "KONGU ENGINEERING COLLEGE",
      title: "Engineering College",
      rating: 5,
      id: useId(),
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => entry.isIntersecting && setIsVisible(true),
      { threshold: 0.1 }
    );
    const element = document.querySelector('[data-section="testimonials"]');
    if (element) observer.observe(element);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const id = setInterval(
      () => setActiveIndex((prev) => (prev + 1) % testimonials.length),
      AUTOPLAY_MS
    );
    return () => clearInterval(id);
  }, [testimonials.length]);

  // Circular window of cards; the leading card carries the accent fill.
  const visible = Array.from(
    { length: VISIBLE_CARDS },
    (_, offset) => testimonials[(activeIndex + offset) % testimonials.length]
  );

  return (
    <section data-section="testimonials" className="bg-white py-20">
      <Container>
        <SectionHead
          eyebrow="Client Testimonials"
          title={
            <>
              What our clients are
              <br />
              saying about us
            </>
          }
          subtitle="Hear from leading educational institutions about their experience with SMART Training Resources."
        />

        <div className="grid gap-6 lg:grid-cols-3">
          {visible.map((testimonial, index) => {
            const isLead = index === 0;
            return (
              <Card
                key={testimonial.id}
                tone={isLead ? "accent" : "white"}
                className={`flex flex-col p-6 ${
                  index === 2 ? "hidden lg:flex" : ""
                } ${index === 1 ? "hidden sm:flex" : ""} ${
                  isVisible ? "animate-fade-in-up" : "opacity-0"
                }`}
              >
                <div className="mb-4 flex gap-1">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <FaStar
                      key={i}
                      className={`h-3.5 w-3.5 ${
                        isLead ? "text-white" : "text-baseYellow"
                      }`}
                    />
                  ))}
                </div>

                <h3
                  className={`mb-3 text-base font-bold ${
                    isLead ? "text-white" : "text-ink"
                  }`}
                >
                  {testimonial.title}
                </h3>

                <p
                  className={`flex-1 text-sm leading-relaxed ${
                    isLead ? "text-white/80" : "text-darkgrey"
                  }`}
                  style={clampStyle}
                >
                  {testimonial.text}
                </p>

                <div
                  className={`mt-6 flex items-center gap-3 border-t pt-5 ${
                    isLead ? "border-white/20" : "border-brand-100"
                  }`}
                >
                  <div className="flex h-12 w-12 flex-shrink-0 items-center justify-center overflow-hidden rounded-full bg-white p-1.5">
                    <img
                      src={testimonial.image}
                      alt={testimonial.name}
                      className="h-full w-full object-contain"
                    />
                  </div>
                  <div
                    className={`text-sm font-bold ${
                      isLead ? "text-white" : "text-ink"
                    }`}
                  >
                    {testimonial.name}
                  </div>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Indicators */}
        <div className="mt-8 flex items-center justify-center gap-2">
          {testimonials.map((testimonial, index) => (
            <button
              key={testimonial.id}
              onClick={() => setActiveIndex(index)}
              aria-label={`Show testimonial ${index + 1}`}
              className={`h-2 rounded-full transition-all duration-300 ${
                activeIndex === index
                  ? "w-8 bg-brand"
                  : "w-2 bg-brand-300 hover:bg-brand/50"
              }`}
            />
          ))}
        </div>

        {/* Aggregate figures */}
        <div className="mt-16 rounded-3xl bg-brand-50 p-8 sm:p-12">
          <div className="mx-auto mb-10 max-w-2xl text-center">
            <h3 className="text-2xl font-bold text-ink sm:text-3xl">
              Trusted by leading institutions
            </h3>
            <p className="mt-3 text-darkgrey">
              Join thousands of satisfied clients
            </p>
          </div>
          <div className="grid grid-cols-2 gap-6 lg:grid-cols-4">
            {[
              { number: "1200+", label: "Campus Partners" },
              { number: "4M+", label: "Students Trained" },
              { number: "24+", label: "Years Experience" },
              { number: "98%", label: "Satisfaction Rate" },
            ].map((stat) => (
              <div key={stat.label} className="text-center">
                <div className="text-3xl font-bold text-brand sm:text-4xl">
                  {stat.number}
                </div>
                <div className="mt-1 text-xs font-semibold uppercase tracking-wider text-darkgrey">
                  {stat.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default Testimonials1;
